module.exports = __webpack_public_path__ + "static/media/googlehome-assistant.858de614.png";